function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22 44a22 22 0 100-44 22 22 0 000 44zm0-2.44a19.56 19.56 0 110-39.12 19.56 19.56 0 010 39.12z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 35a13 13 0 100-26 13 13 0 000 26zm0-2.4a10.6 10.6 0 110-21.2 10.6 10.6 0 010 21.2z"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 4
});
function SvgGoal(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 46",
    ref: svgRef
  }, props), _ref, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default ForwardRef;